kits_translations = {
    "view_kit": {
        en: "View Kit",
        cn: "查看媒体工具包",
        es: "Ver kit",
        pt: "Visualizar o kit",
        ru: "Просмотреть пакет",
    },
};
